var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "friendship-level-root",
      style: `paddingTop:${_vm.barHeight}px`,
    },
    [
      _c("van-nav-bar", {
        staticClass: "van-bar",
        attrs: { title: "", "left-arrow": "" },
        on: { "click-left": _vm.closeWeb },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "left-nav",
                  attrs: {
                    src: require("@/assets/packageAssets/common/arrow05.png"),
                    alt: "",
                  },
                  on: { "click-left": _vm.closeWeb },
                }),
                _c("span", { staticClass: "tit-left" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("lang.intimate.pageTitNew")) + " "
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "right",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "more-btn arLeftP16",
                    on: { click: _vm.handleMore },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/more.png"),
                        alt: "",
                      },
                    }),
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.showMore
                        ? _c("div", { staticClass: "more-list arMoreList" }, [
                            _c(
                              "div",
                              {
                                staticClass: "span1",
                                on: { click: _vm.aboutBond },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("lang.intimate.aboutBondNew"))
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "line" }),
                            _vm.data.fromGender == 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "span2",
                                    on: { click: _vm.removeBond },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("lang.intimate.removeBondNew")
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "avatar" }, [
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.data.fromAvatar,
              expression: "data.fromAvatar",
            },
          ],
          attrs: { src: _vm._f("imgPath")(_vm.data.fromAvatar), alt: "avatar" },
        }),
        _c("div", { staticClass: "level-love" }, [
          _vm.data.fromAvatar
            ? _c("p", { staticClass: "level-num" }, [
                _vm._v(
                  _vm._s(_vm.$t("lang.Lv")) + "." + _vm._s(_vm.data.grade)
                ),
              ])
            : _vm._e(),
          _c("p", { staticClass: "intimate-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.data.togetherDays) + " ")]),
            _c("i", [
              _vm._v(
                _vm._s(
                  _vm.data.togetherDays == 1
                    ? _vm.$t("lang.sevenKeepSignin.day")
                    : _vm.$t("lang.intimate.days")
                )
              ),
            ]),
          ]),
        ]),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.data.fromAvatar,
              expression: "data.fromAvatar",
            },
          ],
          attrs: {
            src: _vm._f("imgPath")(_vm.data.targetAvatar),
            alt: "avatar",
          },
        }),
      ]),
      _c("div", { staticClass: "progress" }, [
        _c(
          "div",
          { staticClass: "progress-item" },
          [
            _c("van-progress", {
              staticClass: "progress-bar",
              attrs: {
                color: "#A338FC",
                "track-color": "#ffe9fc",
                "show-pivot": false,
                percentage: _vm.percentageVal,
                "stroke-width": "11",
              },
            }),
            _vm.data.grade == _vm.data.nextGrade
              ? _c("span", { staticClass: "progress-text" }, [
                  _vm._v(_vm._s(_vm.$t("lang.intimate.max"))),
                ])
              : _c("span", { staticClass: "progress-text" }, [
                  _vm._v(
                    _vm._s(_vm.data.score) +
                      "/" +
                      _vm._s(_vm.data.nextGradeMinScore)
                  ),
                ]),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "level" }, [
        _c("div", { staticClass: "level-item currentLevel" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("lang.Lv")) + "." + _vm._s(_vm.data.grade)),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "level-tip", on: { click: _vm.handleToRule } },
          [
            _vm.data.grade == _vm.data.nextGrade
              ? _c("span", [_vm._v(_vm._s(_vm.$t("lang.intimate.maxLevel")))])
              : _c("span", { staticClass: "level-tip-text" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.data.nextGradeMinScore - _vm.data.score) +
                      "  " +
                      _vm._s(
                        _vm.data.nextGradeMinScore - _vm.data.score == 1
                          ? _vm.$t("lang.intimate.point")
                          : _vm.$t("lang.intimate.points")
                      ) +
                      " " +
                      _vm._s(_vm.$t("lang.host.toLevelUp")) +
                      " "
                  ),
                ]),
            _c("img", {
              attrs: {
                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/rules.png"),
                alt: "rules",
              },
            }),
          ]
        ),
        _c(
          "div",
          { staticClass: "level-item" },
          [
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("lang.Lv")) + "." + _vm._s(_vm.data.nextGrade)
                ),
              ]),
            ],
          ],
          2
        ),
      ]),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "days" }, [
          _c("div", { staticClass: "days-text" }, [
            _c("div", { staticClass: "days-data" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.intimate.message")))]),
              _c("i", [_vm._v(_vm._s(_vm.data.chatMsgCount))]),
            ]),
            _c("div", { staticClass: "days-data" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.mybean.gifts")))]),
              _c("i", [_vm._v(_vm._s(_vm.data.presentGiftCount))]),
            ]),
            _c("div", { staticClass: "days-data" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.intimate.video")))]),
              _c("i", [_vm._v(_vm._s(_vm.time))]),
            ]),
          ]),
          _c("div", { staticClass: "last-chat-time arRightTextLastTime" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("lang.intimate.lastContactOn")) +
                " " +
                _vm._s(
                  _vm.handleMoment(_vm.data.lastConnectTime, "DD/MM/YYYY")
                ) +
                " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "reward-list" }, [
          _c("div", { staticClass: "title" }, [
            _c("img", {
              staticClass: "arArrow",
              staticStyle: { "margin-right": "-1px" },
              attrs: {
                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/day_left.png"),
                alt: "",
              },
            }),
            _c("div", { staticClass: "tit" }, [
              _vm._v(
                _vm._s(
                  _vm.data.fromGender == 1
                    ? _vm.$t("lang.intimate.privilegesRewards")
                    : _vm.$t("lang.intimate.reward")
                )
              ),
            ]),
            _c("img", {
              staticClass: "arArrow",
              staticStyle: { "margin-left": "-1px" },
              attrs: {
                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/day_right.png"),
                alt: "",
              },
            }),
          ]),
          _vm.data && !_vm.data.ifNewRuleFriend
            ? _c(
                "div",
                { staticClass: "steps-box step-v1" },
                [
                  _c(
                    "van-steps",
                    {
                      attrs: {
                        direction: "vertical",
                        active: _vm.data.grade - 1,
                      },
                    },
                    _vm._l(_vm.rewardList, function (item) {
                      return _c("van-step", { key: item.grade }, [
                        _c("div", { staticClass: "reward-item-list" }, [
                          _c("div", { staticClass: "reward-level" }, [
                            _vm._v(
                              _vm._s(_vm.$t("lang.Lv")) +
                                "." +
                                _vm._s(item.grade)
                            ),
                          ]),
                          item.ifRewardProp
                            ? _c("div", { staticClass: "treasure-root" }, [
                                _c(
                                  "div",
                                  { staticClass: "privilege-wrapper" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "privilege-item" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "image-wrapper" },
                                          [
                                            item.ifTakeReward
                                              ? [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/chest_unlocked.png"),
                                                      alt: "",
                                                      width: "40",
                                                      height: "40",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.rewardProp(
                                                          item.props,
                                                          item.grade
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("img", {
                                                    staticClass: "status-icon",
                                                    attrs: {
                                                      src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                      alt: "",
                                                    },
                                                  }),
                                                ]
                                              : [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/chest_locked.png"),
                                                      alt: "",
                                                      width: "40",
                                                      height: "40",
                                                    },
                                                  }),
                                                  _c("img", {
                                                    staticClass: "status-icon",
                                                    attrs: {
                                                      src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png"),
                                                      alt: "",
                                                    },
                                                  }),
                                                ],
                                          ],
                                          2
                                        ),
                                        _c("div", { staticClass: "title1" }, [
                                          _c(
                                            "span",
                                            {
                                              class: {
                                                noRewardText:
                                                  item.grade > _vm.data.grade,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("lang.intimate.chest")
                                                ) +
                                                  "(" +
                                                  _vm._s(_vm.$t("lang.Lv")) +
                                                  "." +
                                                  _vm._s(item.grade) +
                                                  ")"
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c("div", { staticClass: "title2" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.ifTakeReward
                                                  ? _vm.$t(
                                                      "lang.intimate.unlockedAtLevel"
                                                    )
                                                  : _vm.$t(
                                                      "lang.intimate.unlockAtLevel"
                                                    ) +
                                                      " " +
                                                      item.grade
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          item.ifRewardPrivilege
                            ? _c(
                                "div",
                                { staticClass: "privilege-root" },
                                [
                                  _vm.data.fromGender == 1
                                    ? [
                                        item.grade == 1
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "privilege-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "privilege-item",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "image-wrapper",
                                                        },
                                                        [
                                                          item.grade <=
                                                          _vm.data.grade
                                                            ? [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_messages.png"),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ]
                                                            : [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_messages.png"),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ],
                                                        ],
                                                        2
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "title",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                noRewardText:
                                                                  item.grade >
                                                                  _vm.data
                                                                    .grade,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "lang.intimate.messagesFree"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "privilege-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "privilege-item",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "image-wrapper",
                                                        },
                                                        [
                                                          item.grade <=
                                                          _vm.data.grade
                                                            ? [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_send.png"),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ]
                                                            : [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_send.png"),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ],
                                                        ],
                                                        2
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "title",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                noRewardText:
                                                                  item.grade >
                                                                  _vm.data
                                                                    .grade,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "lang.intimate.sendPhotos"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        item.grade == 3
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "privilege-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "privilege-item",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "image-wrapper",
                                                        },
                                                        [
                                                          item.grade <=
                                                          _vm.data.grade
                                                            ? [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_private.png"),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ]
                                                            : [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_private.png"),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ],
                                                        ],
                                                        2
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "title",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                noRewardText:
                                                                  item.grade >
                                                                  _vm.data
                                                                    .grade,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "lang.intimate.unlockVideos"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ]
                                    : [
                                        item.grade == 1
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "privilege-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "privilege-item",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "image-wrapper",
                                                        },
                                                        [
                                                          item.grade <=
                                                          _vm.data.grade
                                                            ? [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_send.png"),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ]
                                                            : [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_send.png"),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ],
                                                        ],
                                                        2
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "title",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                noRewardText:
                                                                  item.grade >
                                                                  _vm.data
                                                                    .grade,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "lang.intimate.sendPhotos"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              item.rewardBeanNumber
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "privilege-wrapper",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "privilege-item",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "image-wrapper",
                                                            },
                                                            [
                                                              item.grade <=
                                                              _vm.data.grade
                                                                ? [
                                                                    _c("img", {
                                                                      attrs: {
                                                                        src: _vm.getMatchImg(
                                                                          "beans"
                                                                        ),
                                                                        alt: "",
                                                                        width:
                                                                          "40",
                                                                        height:
                                                                          "40",
                                                                      },
                                                                    }),
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "status-icon",
                                                                      attrs: {
                                                                        src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                        alt: "",
                                                                      },
                                                                    }),
                                                                  ]
                                                                : [
                                                                    _c("img", {
                                                                      attrs: {
                                                                        src: _vm.getMatchImg(
                                                                          "beans-off"
                                                                        ),
                                                                        alt: "",
                                                                        width:
                                                                          "40",
                                                                        height:
                                                                          "40",
                                                                      },
                                                                    }),
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "status-icon",
                                                                      attrs: {
                                                                        src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png"),
                                                                        alt: "",
                                                                      },
                                                                    }),
                                                                  ],
                                                            ],
                                                            2
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "title",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  class: {
                                                                    noRewardText:
                                                                      item.grade >
                                                                      _vm.data
                                                                        .grade,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "2 " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "lang.mybean.beans"
                                                                        )
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm._e(),
                                        item.grade == 2 && item.rewardBeanNumber
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "privilege-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "privilege-item",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "image-wrapper",
                                                        },
                                                        [
                                                          item.grade <=
                                                          _vm.data.grade
                                                            ? [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: _vm.getMatchImg(
                                                                      "beans"
                                                                    ),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ]
                                                            : [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: _vm.getMatchImg(
                                                                      "beans-off"
                                                                    ),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ],
                                                        ],
                                                        2
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "title",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                noRewardText:
                                                                  item.grade >
                                                                  _vm.data
                                                                    .grade,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.rewardBeanNumber
                                                                ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "lang.mybean.beans"
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        item.grade == 3 && item.rewardBeanNumber
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "privilege-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "privilege-item",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "image-wrapper",
                                                        },
                                                        [
                                                          item.grade <=
                                                          _vm.data.grade
                                                            ? [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: _vm.getMatchImg(
                                                                      "beans"
                                                                    ),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ]
                                                            : [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: _vm.getMatchImg(
                                                                      "beans-off"
                                                                    ),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ],
                                                        ],
                                                        2
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "title",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                noRewardText:
                                                                  item.grade >
                                                                  _vm.data
                                                                    .grade,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.rewardBeanNumber
                                                                ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "lang.mybean.beans"
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        item.grade == 4 && item.rewardBeanNumber
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "privilege-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "privilege-item",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "image-wrapper",
                                                        },
                                                        [
                                                          item.grade <=
                                                          _vm.data.grade
                                                            ? [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: _vm.getMatchImg(
                                                                      "beans"
                                                                    ),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ]
                                                            : [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: _vm.getMatchImg(
                                                                      "beans-off"
                                                                    ),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ],
                                                        ],
                                                        2
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "title",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                noRewardText:
                                                                  item.grade >
                                                                  _vm.data
                                                                    .grade,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.rewardBeanNumber
                                                                ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "lang.mybean.beans"
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        item.grade == 5 && item.rewardBeanNumber
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "privilege-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "privilege-item",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "image-wrapper",
                                                        },
                                                        [
                                                          item.grade <=
                                                          _vm.data.grade
                                                            ? [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: _vm.getMatchImg(
                                                                      "beans"
                                                                    ),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ]
                                                            : [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: _vm.getMatchImg(
                                                                      "beans-off"
                                                                    ),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ],
                                                        ],
                                                        2
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "title",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                noRewardText:
                                                                  item.grade >
                                                                  _vm.data
                                                                    .grade,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.rewardBeanNumber
                                                                ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "lang.mybean.beans"
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        item.grade == 6 && item.rewardBeanNumber
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "privilege-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "privilege-item",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "image-wrapper",
                                                        },
                                                        [
                                                          item.grade <=
                                                          _vm.data.grade
                                                            ? [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: _vm.getMatchImg(
                                                                      "beans"
                                                                    ),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ]
                                                            : [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: _vm.getMatchImg(
                                                                      "beans-off"
                                                                    ),
                                                                    alt: "",
                                                                    width: "40",
                                                                    height:
                                                                      "40",
                                                                  },
                                                                }),
                                                                _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/lock_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                              ],
                                                        ],
                                                        2
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "title",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                noRewardText:
                                                                  item.grade >
                                                                  _vm.data
                                                                    .grade,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.rewardBeanNumber
                                                                ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "lang.mybean.beans"
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                ],
                                2
                              )
                            : _vm._e(),
                        ]),
                      ])
                    }),
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "steps-box step-v2" },
                [
                  _vm.data.fromGender == 1
                    ? _vm._l(_vm.rewardListNew, function (item) {
                        return _c(
                          "div",
                          { key: item.grade, staticClass: "reward-item-list" },
                          [
                            _c("div", { staticClass: "reward-level" }, [
                              _vm._v(
                                _vm._s(_vm.$t("lang.Lv")) +
                                  "." +
                                  _vm._s(item.grade)
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "privilege-root" },
                              [
                                item.grade == 1
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "privilege-wrapper",
                                          attrs: { id: "male-grade1-type0" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleGet(item, 0)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "image-wrapper",
                                                },
                                                [
                                                  item.grade <= _vm.data.grade
                                                    ? [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_send.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                        item.children[0]
                                                          .ifTakeReward
                                                          ? _c("img", {
                                                              staticClass:
                                                                "status-icon",
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                alt: "",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    : [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_send.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                      ],
                                                ],
                                                2
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "title" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      class: {
                                                        noRewardText:
                                                          item.grade >
                                                          _vm.data.grade,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "lang.intimate.sendPhotos"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "privilege-wrapper",
                                          attrs: { id: "male-grade1-type1" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleGet(item, 1)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "image-wrapper",
                                                },
                                                [
                                                  item.grade <= _vm.data.grade
                                                    ? [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_messages.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                        item.children[1]
                                                          .ifTakeReward
                                                          ? _c("img", {
                                                              staticClass:
                                                                "status-icon",
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                alt: "",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    : [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_messages.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                      ],
                                                ],
                                                2
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "title" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      class: {
                                                        noRewardText:
                                                          item.grade >
                                                          _vm.data.grade,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "lang.commonM.k151"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                item.grade == 2
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "privilege-wrapper",
                                          attrs: { id: "male-grade2-type0" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleGet(item, 0)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "image-wrapper",
                                                },
                                                [
                                                  item.grade <= _vm.data.grade
                                                    ? [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_coupon.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                        item.children[0]
                                                          .ifTakeReward
                                                          ? _c("img", {
                                                              staticClass:
                                                                "status-icon",
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                alt: "",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    : [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_coupon.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                      ],
                                                ],
                                                2
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "title" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      class: {
                                                        noRewardText:
                                                          item.grade >
                                                          _vm.data.grade,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "lang.giftSign.coupon"
                                                          )
                                                        ) + " x1"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "privilege-wrapper",
                                          attrs: { id: "male-grade2-type1" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleGet(
                                                    item,
                                                    1,
                                                    "gem"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "image-wrapper",
                                                },
                                                [
                                                  item.grade <= _vm.data.grade
                                                    ? [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_chocolate.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                        item.children[1]
                                                          .ifTakeReward
                                                          ? _c("img", {
                                                              staticClass:
                                                                "status-icon",
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                alt: "",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    : [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_chocolate.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                      ],
                                                ],
                                                2
                                              ),
                                              item.children[1]
                                                ? _c(
                                                    "div",
                                                    { staticClass: "title" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          class: {
                                                            noRewardText:
                                                              item.grade >
                                                              _vm.data.grade,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.children[1]
                                                                .propName
                                                            ) + " x1"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  : item.grade == 3
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "privilege-wrapper",
                                          attrs: { id: "male-grade3-type0" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleGet(item, 0)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "image-wrapper",
                                                },
                                                [
                                                  item.grade <= _vm.data.grade
                                                    ? [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_coupon.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                        item.children[0]
                                                          .ifTakeReward
                                                          ? _c("img", {
                                                              staticClass:
                                                                "status-icon",
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                alt: "",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    : [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_coupon.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                      ],
                                                ],
                                                2
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "title" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      class: {
                                                        noRewardText:
                                                          item.grade >
                                                          _vm.data.grade,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "lang.giftSign.coupon"
                                                          )
                                                        ) + " x1"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "privilege-wrapper",
                                          attrs: { id: "male-grade3-type1" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleGet(item, 1)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "image-wrapper",
                                                },
                                                [
                                                  item.grade <= _vm.data.grade
                                                    ? [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_private.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                        item.children[1]
                                                          .ifTakeReward
                                                          ? _c("img", {
                                                              staticClass:
                                                                "status-icon",
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                alt: "",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    : [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_private.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                      ],
                                                ],
                                                2
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "title" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      class: {
                                                        noRewardText:
                                                          item.grade >
                                                          _vm.data.grade,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "lang.intimate.unlockVideos"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  : item.grade == 4
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "privilege-wrapper",
                                          attrs: { id: "male-grade4-type0" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleGet(item, 0)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "image-wrapper",
                                                },
                                                [
                                                  item.grade <= _vm.data.grade
                                                    ? [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_coupon.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                        item.children[0]
                                                          .ifTakeReward
                                                          ? _c("img", {
                                                              staticClass:
                                                                "status-icon",
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                alt: "",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    : [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_coupon.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                      ],
                                                ],
                                                2
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "title" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      class: {
                                                        noRewardText:
                                                          item.grade >
                                                          _vm.data.grade,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "lang.giftSign.coupon"
                                                          )
                                                        ) + " x1"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "privilege-wrapper",
                                          attrs: { id: "male-grade4-type1" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleGet(
                                                    item,
                                                    1,
                                                    "rose"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "image-wrapper",
                                                },
                                                [
                                                  item.grade <= _vm.data.grade
                                                    ? [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_bunnyposy.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                        item.children[1]
                                                          .ifTakeReward
                                                          ? _c("img", {
                                                              staticClass:
                                                                "status-icon",
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                alt: "",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    : [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_bunnyposy.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                      ],
                                                ],
                                                2
                                              ),
                                              item.children[1]
                                                ? _c(
                                                    "div",
                                                    { staticClass: "title" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          class: {
                                                            noRewardText:
                                                              item.grade >
                                                              _vm.data.grade,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.children[1]
                                                                .propName
                                                            ) + " x1"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  : item.grade == 5
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "privilege-wrapper",
                                          attrs: { id: "male-grade5-type0" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleGet(item, 0)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "image-wrapper",
                                                },
                                                [
                                                  item.grade <= _vm.data.grade
                                                    ? [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_coupon.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                        item.children[0]
                                                          .ifTakeReward
                                                          ? _c("img", {
                                                              staticClass:
                                                                "status-icon",
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                alt: "",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    : [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_coupon.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                      ],
                                                ],
                                                2
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "title" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      class: {
                                                        noRewardText:
                                                          item.grade >
                                                          _vm.data.grade,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "lang.giftSign.coupon"
                                                          )
                                                        ) + " x1"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  : item.grade == 6
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "privilege-wrapper",
                                          attrs: { id: "male-grade6-type0" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleGet(item, 0)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "image-wrapper",
                                                },
                                                [
                                                  item.grade <= _vm.data.grade
                                                    ? [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_coupon.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                        item.children[0]
                                                          .ifTakeReward
                                                          ? _c("img", {
                                                              staticClass:
                                                                "status-icon",
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                alt: "",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    : [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_coupon.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                      ],
                                                ],
                                                2
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "title" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      class: {
                                                        noRewardText:
                                                          item.grade >
                                                          _vm.data.grade,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "lang.giftSign.coupon"
                                                          )
                                                        ) + " x1"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "privilege-wrapper",
                                          attrs: { id: "male-grade6-type1" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleGet(
                                                    item,
                                                    1,
                                                    "dream"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "image-wrapper",
                                                },
                                                [
                                                  item.grade <= _vm.data.grade
                                                    ? [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_purse.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                        item.children[1]
                                                          .ifTakeReward
                                                          ? _c("img", {
                                                              staticClass:
                                                                "status-icon",
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                alt: "",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    : [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_purse.png"),
                                                            alt: "",
                                                            width: "40",
                                                            height: "40",
                                                          },
                                                        }),
                                                      ],
                                                ],
                                                2
                                              ),
                                              item.children[1]
                                                ? _c(
                                                    "div",
                                                    { staticClass: "title" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          class: {
                                                            noRewardText:
                                                              item.grade >
                                                              _vm.data.grade,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.children[1]
                                                                .propName
                                                            ) + " x1"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        )
                      })
                    : _vm._e(),
                  _vm.data.fromGender == 2
                    ? _vm._l(_vm.rewardListNew, function (item) {
                        return _c(
                          "div",
                          { key: item.grade, staticClass: "reward-item-list" },
                          [
                            item.grade == 1 ||
                            item.grade == 3 ||
                            item.grade == 5
                              ? _c("div", { staticClass: "reward-level" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("lang.Lv")) +
                                      "." +
                                      _vm._s(item.grade)
                                  ),
                                ])
                              : _vm._e(),
                            [1, 3, 5].includes(item.grade)
                              ? _c(
                                  "div",
                                  { staticClass: "privilege-root" },
                                  [
                                    item.grade == 1
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-wrapper",
                                              attrs: {
                                                id: "female-grade1-type0",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "privilege-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleGet(
                                                        item,
                                                        0
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "image-wrapper",
                                                    },
                                                    [
                                                      item.grade <=
                                                      _vm.data.grade
                                                        ? [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_send.png"),
                                                                alt: "",
                                                                width: "40",
                                                                height: "40",
                                                              },
                                                            }),
                                                            item.children[0]
                                                              .ifTakeReward
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        : [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_send.png"),
                                                                alt: "",
                                                                width: "40",
                                                                height: "40",
                                                              },
                                                            }),
                                                          ],
                                                    ],
                                                    2
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "title" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          class: {
                                                            noRewardText:
                                                              item.grade >
                                                              _vm.data.grade,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "lang.intimate.sendPhotos"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-wrapper",
                                              attrs: {
                                                id: "female-grade1-type1",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "privilege-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleGet(
                                                        item,
                                                        1,
                                                        "cocktail"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "image-wrapper",
                                                    },
                                                    [
                                                      item.grade <=
                                                      _vm.data.grade
                                                        ? [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_cocktail.png"),
                                                                alt: "",
                                                                width: "40",
                                                                height: "40",
                                                              },
                                                            }),
                                                            item.children[1]
                                                              .ifTakeReward
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        : [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_cocktail.png"),
                                                                alt: "",
                                                                width: "40",
                                                                height: "40",
                                                              },
                                                            }),
                                                          ],
                                                    ],
                                                    2
                                                  ),
                                                  item.children[1]
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass: "title",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                noRewardText:
                                                                  item.grade >
                                                                  _vm.data
                                                                    .grade,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item
                                                                    .children[1]
                                                                    .propName
                                                                ) + " x1"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                    item.grade == 3
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-wrapper",
                                              attrs: {
                                                id: "female-grade3-type0",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "privilege-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleGet(
                                                        item,
                                                        0,
                                                        "cocktail"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "image-wrapper",
                                                    },
                                                    [
                                                      item.grade <=
                                                      _vm.data.grade
                                                        ? [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_cocktail.png"),
                                                                alt: "",
                                                                width: "40",
                                                                height: "40",
                                                              },
                                                            }),
                                                            item.children[0]
                                                              .ifTakeReward
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        : [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_cocktail.png"),
                                                                alt: "",
                                                                width: "40",
                                                                height: "40",
                                                              },
                                                            }),
                                                          ],
                                                    ],
                                                    2
                                                  ),
                                                  item.children[0]
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass: "title",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                noRewardText:
                                                                  item.grade >
                                                                  _vm.data
                                                                    .grade,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item
                                                                    .children[0]
                                                                    .propName
                                                                ) + " x1"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                    item.grade == 5
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "privilege-wrapper",
                                              attrs: {
                                                id: "female-grade5-type0",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "privilege-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleGet(
                                                        item,
                                                        0,
                                                        "cocktail"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "image-wrapper",
                                                    },
                                                    [
                                                      item.grade <=
                                                      _vm.data.grade
                                                        ? [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_cocktail.png"),
                                                                alt: "",
                                                                width: "40",
                                                                height: "40",
                                                              },
                                                            }),
                                                            item.children[0]
                                                              .ifTakeReward
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_icon.png"),
                                                                    alt: "",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        : [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_un_cocktail.png"),
                                                                alt: "",
                                                                width: "40",
                                                                height: "40",
                                                              },
                                                            }),
                                                          ],
                                                    ],
                                                    2
                                                  ),
                                                  item.children[0]
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass: "title",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                noRewardText:
                                                                  item.grade >
                                                                  _vm.data
                                                                    .grade,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item
                                                                    .children[0]
                                                                    .propName
                                                                ) + " x1"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        )
                      })
                    : _vm._e(),
                  _vm.rewardListNew && _vm.rewardListNew.length
                    ? _c("div", { staticClass: "reward-bar" })
                    : _vm._e(),
                ],
                2
              ),
        ]),
      ]),
      _c("ConfirmAuto", {
        attrs: {
          showDia: _vm.showConfirmAuto,
          title: _vm.title,
          content: _vm.content,
          leftBtnText: _vm.leftBtnText,
          rightBtnText: _vm.rightBtnText,
        },
        on: { leftBtn: _vm.leftBtn, rightBtn: _vm.rightBtn },
      }),
      _c(
        "van-popup",
        {
          staticClass: "popup-box",
          attrs: { "lock-scroll": false },
          on: { close: _vm.closeProp },
          model: {
            value: _vm.showProp,
            callback: function ($$v) {
              _vm.showProp = $$v
            },
            expression: "showProp",
          },
        },
        [
          _c("div", { staticClass: "prop-tit" }, [
            _vm._v(
              _vm._s(_vm.$t("lang.intimate.chest")) +
                "(" +
                _vm._s(_vm.$t("lang.Lv")) +
                "." +
                _vm._s(_vm.chooseBlockGender) +
                ")"
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "prop",
              class: { propNum: _vm.propsList.length > 3 },
            },
            _vm._l(_vm.propsList, function (item, index) {
              return _c("div", { key: index, staticClass: "prop-content" }, [
                item.propType == 1
                  ? _c("img", {
                      attrs: { src: _vm.getMatchImg("chat-pass"), alt: "" },
                    })
                  : _vm._e(),
                item.propType == 3
                  ? _c("img", {
                      attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                    })
                  : _vm._e(),
                item.propType == 9
                  ? _c("img", {
                      attrs: { src: _vm.getMatchImg("coupon"), alt: "" },
                    })
                  : _vm._e(),
                _c("div", { staticClass: "coupon-text" }, [
                  item.propType == 1
                    ? _c("i", [
                        _vm._v(_vm._s(_vm.$t("lang.giftSign.chatPass"))),
                      ])
                    : _vm._e(),
                  item.propType == 9
                    ? _c("i", [_vm._v(_vm._s(_vm.$t("lang.giftSign.coupon")))])
                    : _vm._e(),
                  _vm._v(" x" + _vm._s(item.rewardNumber) + " "),
                  item.extraAmount
                    ? _c("span", { staticClass: "tip" }, [
                        _vm._v(
                          "(" +
                            _vm._s(_vm.$t("lang.coupon.extra")) +
                            " " +
                            _vm._s(item.extraAmount) +
                            ")"
                        ),
                      ])
                    : _vm._e(),
                ]),
              ])
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "close-btn", on: { click: _vm.closeProp } },
            [_vm._v(_vm._s(_vm.$t("lang.intimate.close")))]
          ),
        ]
      ),
      _vm.showNewfriendship && !_vm.laterShowNewfriendship
        ? _c(
            "div",
            {
              staticClass: "dialog-mask",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  _vm.showNewfriendship = false
                },
              },
            },
            [
              _c("div", { staticClass: "friendship-dialog" }, [
                _c("div", { staticClass: "friendship-dia-head" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k156")))]),
                  _c("img", {
                    attrs: { src: require("./images/up-arrow.png") },
                  }),
                ]),
                _vm.data.fromGender === 1
                  ? _c("div", { staticClass: "friendship-dia-bd" }, [
                      _c("div", { staticClass: "friendship-dia-con" }, [
                        _c("div", { staticClass: "friendship-dia-tit" }, [
                          _vm._v(_vm._s(_vm.$t("lang.commonM.k157"))),
                        ]),
                        _c("div", { staticClass: "friendship-tips" }, [
                          _vm._v(_vm._s(_vm.$t("lang.commonM.k158"))),
                        ]),
                        _vm._m(0),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "ok-btn",
                          on: { click: _vm.handleLevelOk },
                        },
                        [_vm._v(_vm._s(_vm.$t("lang.ok")))]
                      ),
                    ])
                  : _vm._e(),
                _vm.data.fromGender === 2
                  ? _c(
                      "div",
                      { staticClass: "friendship-dia-bd" },
                      [
                        _c(
                          "van-swipe",
                          {
                            staticClass: "my-swipe",
                            attrs: { autoplay: 3000 },
                          },
                          [
                            _c("van-swipe-item", [
                              _c("div", { staticClass: "friendship-dia-con" }, [
                                _c(
                                  "div",
                                  { staticClass: "friendship-dia-tit" },
                                  [_vm._v(_vm._s(_vm.$t("lang.commonM.k157")))]
                                ),
                                _c("div", { staticClass: "friendship-tips" }, [
                                  _vm._v(_vm._s(_vm.$t("lang.commonM.k256"))),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "friendship-rewards" },
                                  [
                                    _c("div", [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_cocktail.png"),
                                          alt: "",
                                        },
                                      }),
                                      _c("span", [_vm._v("Lv.1")]),
                                    ]),
                                    _c("div", [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_cocktail.png"),
                                          alt: "",
                                        },
                                      }),
                                      _c("span", [_vm._v("Lv.3")]),
                                    ]),
                                    _c("div", [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_cocktail.png"),
                                          alt: "",
                                        },
                                      }),
                                      _c("span", [_vm._v("Lv.5")]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                            _c("van-swipe-item", [
                              _c("div", { staticClass: "friendship-dia-con" }, [
                                _c(
                                  "div",
                                  { staticClass: "friendship-dia-tit" },
                                  [_vm._v(_vm._s(_vm.$t("lang.commonM.k157")))]
                                ),
                                _c("div", { staticClass: "friendship-tips" }, [
                                  _vm._v(_vm._s(_vm.$t("lang.commonM.k257"))),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "friendship-rewards" },
                                  [
                                    _c("div", [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_chocolate.png"),
                                          alt: "",
                                        },
                                      }),
                                      _c("span", [_vm._v("Lv.2")]),
                                    ]),
                                    _c("div", [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_bunnyposy.png"),
                                          alt: "",
                                        },
                                      }),
                                      _c("span", [_vm._v("Lv.4")]),
                                    ]),
                                    _c("div", [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_purse.png"),
                                          alt: "",
                                        },
                                      }),
                                      _c("span", [_vm._v("Lv.6")]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "ok-btn",
                            on: { click: _vm.handleLevelOk },
                          },
                          [_vm._v(_vm._s(_vm.$t("lang.ok")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      _vm.showSendGift
        ? _c(
            "div",
            {
              staticClass: "dialog-mask",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  _vm.showSendGift = false
                },
              },
            },
            [
              _c("div", { staticClass: "sendgift-dialog" }, [
                _c("div", { staticClass: "sendgift-tit" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k159"))),
                ]),
                _c("div", { staticClass: "sendgift-rewards" }, [
                  _vm.waitSendObj && _vm.waitSendObj.imgType === "gem"
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_chocolate.png"),
                          alt: "",
                        },
                      })
                    : _vm._e(),
                  _vm.waitSendObj && _vm.waitSendObj.imgType === "rose"
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_bunnyposy.png"),
                          alt: "",
                        },
                      })
                    : _vm._e(),
                  _vm.waitSendObj && _vm.waitSendObj.imgType === "dream"
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_purse.png"),
                          alt: "",
                        },
                      })
                    : _vm._e(),
                  _vm.waitSendObj && _vm.waitSendObj.imgType === "cocktail"
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_cocktail.png"),
                          alt: "",
                        },
                      })
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "sendgift-tips" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k160"))),
                ]),
                _c(
                  "div",
                  { staticClass: "send-btn", on: { click: _vm.handleSend } },
                  [_vm._v(_vm._s(_vm.$t("lang.commonM.k161")))]
                ),
                _c(
                  "div",
                  { staticClass: "later-btn", on: { click: _vm.handleLater } },
                  [_vm._v(_vm._s(_vm.$t("lang.commonM.k162")))]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm.guideShow
        ? _c("div", { staticClass: "new-leve-guide" }, [
            _c("div", { staticClass: "guide-top" }, [
              _c("div", { staticClass: "guide-btn" }, [
                _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handleGuideOk.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("lang.ok")))]
                ),
              ]),
              _c("div", { staticClass: "guide-tip1" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k163"))),
              ]),
              _c("div", { staticClass: "guide-tip2" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k164"))),
              ]),
              _c(
                "div",
                {
                  staticClass: "guide-mark",
                  style: { left: `${_vm.targetLoc.l + _vm.targetLoc.w / 2}px` },
                },
                [_c("div")]
              ),
            ]),
            _c(
              "div",
              { staticClass: "guide-middle" },
              [
                _vm.$i18n.locale === "ar"
                  ? [
                      _c("div", {
                        staticClass: "guide-left",
                        staticStyle: { flex: "1" },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "guide-center",
                          style: {
                            width: _vm.targetLoc.w + "px",
                            height: _vm.targetLoc.h + "px",
                          },
                        },
                        [
                          _c("div", { staticClass: "guide-view" }),
                          _vm._m(1),
                          _vm._m(2),
                          _vm._m(3),
                          _vm._m(4),
                        ]
                      ),
                      _c("div", {
                        staticClass: "guide-right",
                        staticStyle: { width: "105px" },
                        style: { width: _vm.targetLoc.l + "px" },
                      }),
                    ]
                  : [
                      _c("div", {
                        staticClass: "guide-left",
                        staticStyle: { width: "105px" },
                        style: { width: _vm.targetLoc.l + "px" },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "guide-center",
                          style: {
                            width: _vm.targetLoc.w + "px",
                            height: _vm.targetLoc.h + "px",
                          },
                        },
                        [
                          _c("div", { staticClass: "guide-view" }),
                          _vm._m(5),
                          _vm._m(6),
                          _vm._m(7),
                          _vm._m(8),
                        ]
                      ),
                      _c("div", {
                        staticClass: "guide-right",
                        staticStyle: { flex: "1" },
                      }),
                    ],
              ],
              2
            ),
            _c("div", {
              staticClass: "guide-bottom",
              style: { height: _vm.targetLoc.b + "px" },
            }),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "friendship-rewards" }, [
      _c("div", [
        _c("img", {
          attrs: {
            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_chocolate.png"),
            alt: "",
          },
        }),
        _c("span", [_vm._v("Lv.2")]),
      ]),
      _c("div", [
        _c("img", {
          attrs: {
            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_bunnyposy.png"),
            alt: "",
          },
        }),
        _c("span", [_vm._v("Lv.4")]),
      ]),
      _c("div", [
        _c("img", {
          attrs: {
            src: require("@/assets/packageAssets/views/P2_Page/FriendshipLevel/vava/get_purse.png"),
            alt: "",
          },
        }),
        _c("span", [_vm._v("Lv.6")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "radius-item radius-item-1" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "radius-item radius-item-2" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "radius-item radius-item-3" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "radius-item radius-item-4" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "radius-item radius-item-1" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "radius-item radius-item-2" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "radius-item radius-item-3" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "radius-item radius-item-4" }, [_c("div")])
  },
]
render._withStripped = true

export { render, staticRenderFns }